<script setup>
import { computed, getCurrentInstance } from 'vue';
import PagePath from '../../common/PagePath.vue';
import Button from "../Button.vue";

const props = defineProps({
    field: Object,
    item: Object
});

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Computed: Parse the stored value as an integer for the PagePath component
const pageId = computed(() => {
    return parseInt(props.item.value);
});

// Methods
const openSiteTreeModal = () => {
    store.dispatch('modals/show', {
        componentName: 'SiteTreeModal',
        obj: {
            pageId: pageId.value,
            // Callback updates the item value directly via the object reference
            onPageSelect: (newPageId) => {
                props.item.value = newPageId;
            }
        }
    });
};
</script>

<template>
    <span>
        <Button @click.native="openSiteTreeModal" class="btn-sm border me-2">
            Browse…
        </Button>
        <PagePath v-if="pageId" :page-id="pageId" class="small"/>
    </span>
</template>